<template>
  <div
    :class="`${props.class} section`"
    :style="{ backgroundColor: props.color, padding: '0 10px' }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  color?: string;
  class?: string;
}>();
</script>
